module.exports = __webpack_public_path__ + "08accb97578101bdf3e9e896422b10bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/gamecenter/en/roulette.jpg
// module id = 642
// module chunks = 30